var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{staticStyle:{"height":"calc(50vh - 40px)"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',[_vm._v("库存Top10物料")]),_c('div',{staticStyle:{"margin-top":"36px"},attrs:{"id":"InventoryTopProduct"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }